const DEFAULT_BANNER_CONFIG = {
  title: 'Ready to make it official?',
  subtitle: null,
};

const BANNER_CONFIGS = {
  'viewmate-business': {
    title: 'For custom pricing, including Site Licensing*, request a formal quote or email us at support@pentalogix.com',
    subtitle: '* A Site License allows an organization to deploy ViewMate across an entire business location, providing employees at that site with convenient access to the software without managing individual user licenses.',
  },
};

export const getBannerConfig = (productSlug) =>
  BANNER_CONFIGS[productSlug] || DEFAULT_BANNER_CONFIG;
